import { render, staticRenderFns } from "./CreateNewSmsCampaignAction.vue?vue&type=template&id=2d88992e"
import script from "./CreateNewSmsCampaignAction.vue?vue&type=script&lang=js"
export * from "./CreateNewSmsCampaignAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports